// ═══════════════════════════════════════════════════════════════════════════
// La pantalla que ve quien apunta la cámara al QR
//
// Antes, un ticket sin sesión llevaba al formulario de siempre: correo,
// contraseña, crear cuenta. En una máquina prestada eso es exactamente la
// fricción que había que quitar — y en un demo, el momento en que se pierde a
// la persona.
//
// Ahora lo primero y más grande es UN BOTÓN. Entrar con una cuenta sigue
// existiendo abajo, chiquito, para quien ya trabaja con otra vinícola y lo
// invitan a una segunda: ese sí quiere su identidad de siempre, no un aparato
// nuevo.
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState } from "react";
import { entrarConTicket, nombreDelDispositivo } from "./dispositivo.js";
import { olvidarTicket } from "./ticket.js";
import { LOGO_BASE64 } from "../pdf/logo.js";
import { btnPrimary, btnSecondary } from "../ui/estilos.js";

export function EntrarConTicket({ codigo, onEntro, onPrefiereCuenta }) {
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState("");
  const [listo, setListo] = useState(null);
  const [nombre, setNombre] = useState(() => nombreDelDispositivo());

  const entrar = async () => {
    setOcupado(true); setError("");
    try {
      const r = await entrarConTicket(codigo, nombre);
      setListo(r);
      // Un instante para que se lea a dónde entró, y adentro.
      setTimeout(() => onEntro?.(r), 1200);
    } catch (e) {
      setError(e.message);
      setOcupado(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center",
                  justifyContent: "center", background: "#0a0a0a", padding: 20 }}>
      <div style={{ maxWidth: 400, width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <img src={LOGO_BASE64} alt="" style={{ width: 64, height: 64, objectFit: "contain" }} />
        </div>

        {listo ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>✓</div>
            <div style={{ fontSize: 18, color: "#e8e0d4", marginBottom: 6 }}>
              Entraste a {listo.tenant || "la vinícola"}
            </div>
            <div style={{ fontSize: 12, color: "#666" }}>Un momento…</div>
          </div>
        ) : (
          <>
            <div style={{ textAlign: "center", marginBottom: 18 }}>
              <div style={{ fontSize: 11, color: "#a8d060", letterSpacing: 2, marginBottom: 8 }}>
                TIENES UNA INVITACIÓN
              </div>
              <div style={{ fontFamily: "monospace", fontSize: 22, fontWeight: 700,
                            color: "#c9d8a0", letterSpacing: 3 }}>
                {codigo}
              </div>
            </div>

            {/* El nombre se PROPONE y se puede corregir. Preguntárselo en blanco
                a alguien que apenas está entrando es fricción; no poder
                cambiarlo deja al que administra con cinco «Android · Chrome»
                idénticos el día que haya que revocar uno. */}
            <label style={{ display: "block", fontSize: 10, color: "#666",
                            letterSpacing: 1, marginBottom: 4 }}>
              CÓMO SE VA A LLAMAR ESTE APARATO
            </label>
            <input value={nombre} onChange={e => setNombre(e.target.value)}
              disabled={ocupado} maxLength={60}
              style={{ width: "100%", padding: "10px 12px", background: "#111",
                       border: "1px solid #222", borderRadius: 8, color: "#e8e0d4",
                       fontSize: 14, fontFamily: "inherit", marginBottom: 14 }} />

            <button onClick={entrar} disabled={ocupado}
              style={{ ...btnPrimary, width: "100%", padding: "14px 18px", fontSize: 15,
                       opacity: ocupado ? 0.5 : 1 }}>
              {ocupado ? "Entrando…" : "Entrar en este dispositivo"}
            </button>

            <div style={{ fontSize: 11, color: "#666", lineHeight: 1.7, marginTop: 12 }}>
              No hace falta correo ni contraseña. Este aparato queda dentro hasta
              que alguien lo dé de baja; si lo pierdes, pide otra invitación.
            </div>

            {error && (
              <div style={{ marginTop: 14, padding: "10px 12px", background: "#1f0d0d",
                            border: "1px solid #3a1a1a", borderRadius: 8,
                            fontSize: 12, color: "#f87171" }}>
                {error}
              </div>
            )}

            <button onClick={onPrefiereCuenta} disabled={ocupado}
              style={{ ...btnSecondary, width: "100%", marginTop: 18, padding: "10px 16px",
                       fontSize: 12, opacity: ocupado ? 0.4 : 1 }}>
              Ya tengo una cuenta, quiero usarla
            </button>

            {/* ── La salida ────────────────────────────────────────────────
                El código vive en `localStorage` para sobrevivir el ida y vuelta
                del correo, así que puede quedarse ahí después de usarse. El
                operador se topó con eso: la pantalla reaparecía con un código
                gastado y sin manera de salir salvo borrar los datos del
                navegador.

                Ahora se olvida solo —al entrar y al ser rechazado— pero esto se
                queda igual: una puerta que depende de que yo haya previsto
                todos los casos es una puerta que un día no está. */}
            <button onClick={() => { olvidarTicket(); onPrefiereCuenta?.(); }}
              disabled={ocupado}
              style={{ background: "none", border: "none", width: "100%",
                       marginTop: 10, padding: 6, fontSize: 11, color: "#555",
                       cursor: "pointer", fontFamily: "inherit",
                       textDecoration: "underline", opacity: ocupado ? 0.4 : 1 }}>
              Esta invitación no es mía — descartarla
            </button>
          </>
        )}
      </div>
    </div>
  );
}
